var map = {
	"./arrow-dark.svg": 1490,
	"./arrow-light.svg": 47,
	"./blot-dark-hover.svg": 7348,
	"./blot-dark.svg": 3028,
	"./blot-light-hover.svg": 1746,
	"./blot-light.svg": 267,
	"./check-mark-circle-dark.svg": 2715,
	"./check-mark-circle-light.svg": 4892,
	"./cross-2-dark.svg": 1140,
	"./cross-2-light.svg": 4222,
	"./cross-dark.svg": 4919,
	"./cross-light.svg": 1423,
	"./download-dark.svg": 2696,
	"./download-light.svg": 1676,
	"./eye.svg": 5564,
	"./glass-dark.svg": 8942,
	"./glass-light.svg": 1794,
	"./link.svg": 7966,
	"./menu-burger-dark.svg": 3617,
	"./menu-burger-light.svg": 5963,
	"./pointer-menu-dark.svg": 9014,
	"./pointer-menu-light.svg": 7183,
	"./save-dark.svg": 4252,
	"./save-light.svg": 7715,
	"./setting-icon-dark.svg": 1562,
	"./setting-icon-light.svg": 9298,
	"./single-arrow-bottom-dark.svg": 1137,
	"./single-arrow-bottom-light.svg": 7636,
	"./single-arrow-bottom-two-light.svg": 8723,
	"./single-arrow-left-dark.svg": 3197,
	"./single-arrow-left-light.svg": 9165,
	"./single-arrow-right-dark.svg": 4483,
	"./single-arrow-right-light.svg": 4421,
	"./single-arrow-top-dark.svg": 8998,
	"./single-arrow-top-light.svg": 3102,
	"./single-arrow-top-two-light.svg": 6527,
	"./small-blot-dark.svg": 7500,
	"./small-blot-light.svg": 7997,
	"./toggle-dark-hover.svg": 723,
	"./toggle-dark.svg": 5049,
	"./toggle-light-hover.svg": 4590,
	"./toggle-light.svg": 7965,
	"./user-dark.svg": 5347,
	"./user-light.svg": 5968,
	"./user-support-dark.svg": 4370,
	"./user-support-light.svg": 7017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;